define("shared/components/shared/collapsable-info-card", ["exports", "@ember/component", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "shared/utils/constants/keys", "shared/utils/handle-key-up", "@ember/template-factory"], function (_exports, _component, _object, _utils, _component2, _tracking, _keys, _handleKeyUp, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _handleToggleActions;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/utils/constants/keys",0,"shared/utils/handle-key-up",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cIC--card" data-test-id="collapsable-info-card" ...attributes {{did-insert this.hideOnInit}}>
    <div class="cIC--cardHeader">
      <p class="cIC--cardHeader__title">
        {{@title}}
        {{#if (and @titleHelper this.isCollapsed)}}
          <span class="u--text--light u--text--sm u--text--hair u--m__l__xs">{{@titleHelper}}</span>
        {{/if}}
      </p>
      {{! template-lint-disable no-pointer-down-event-binding }}
      <span
        class="cIC--cardHeader__icon {{@qaClass}}"
        {{on "click" this.toggleCollapsed}}
        {{on "keyup" this.toggleMultiCalProfileKeyboard}}
      >
        {{#if @showAsText}}
          <Shared::Ui::Button
            @size="small"
            @text={{if this.isCollapsed (t "shared_words.show") (t "shared_words.hide")}}
            @variant="unstyled"
            class="u--text--hl u--text--uppercase u--text--sm"
            data-test-id={{if this.isCollapsed "expand" "collapse"}}
          />
        {{else}}
          {{svg-jar
            (if this.isCollapsed "add" "minus")
            class="o--icon o--icon--light"
            data-test-id=(if this.isCollapsed "expand" "collapse")
            role="button"
            tabindex="0"
          }}
        {{/if}}
      </span>
    </div>
    {{#unless this.isCollapsed}}
      <div class="cIC--cardBody" data-test-id="collapsable-info-card-content">
        <div>
          {{yield}}
        </div>
      </div>
    {{/unless}}
  </div>
  */
  {
    "id": "UQKjeJL6",
    "block": "[[[11,0],[24,0,\"cIC--card\"],[24,\"data-test-id\",\"collapsable-info-card\"],[17,1],[4,[38,0],[[30,0,[\"hideOnInit\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,\"\\n      \"],[1,[30,2]],[1,\"\\n\"],[41,[28,[37,2],[[30,3],[30,0,[\"isCollapsed\"]]],null],[[[1,\"        \"],[10,1],[14,0,\"u--text--light u--text--sm u--text--hair u--m__l__xs\"],[12],[1,[30,3]],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[1,\"    \"],[11,1],[16,0,[29,[\"cIC--cardHeader__icon \",[30,4]]]],[4,[38,3],[\"click\",[30,0,[\"toggleCollapsed\"]]],null],[4,[38,3],[\"keyup\",[30,0,[\"toggleMultiCalProfileKeyboard\"]]],null],[12],[1,\"\\n\"],[41,[30,5],[[[1,\"        \"],[8,[39,4],[[24,0,\"u--text--hl u--text--uppercase u--text--sm\"],[16,\"data-test-id\",[52,[30,0,[\"isCollapsed\"]],\"expand\",\"collapse\"]]],[[\"@size\",\"@text\",\"@variant\"],[\"small\",[52,[30,0,[\"isCollapsed\"]],[28,[37,5],[\"shared_words.show\"],null],[28,[37,5],[\"shared_words.hide\"],null]],\"unstyled\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,6],[[52,[30,0,[\"isCollapsed\"]],\"add\",\"minus\"]],[[\"class\",\"data-test-id\",\"role\",\"tabindex\"],[\"o--icon o--icon--light\",[52,[30,0,[\"isCollapsed\"]],\"expand\",\"collapse\"],\"button\",\"0\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isCollapsed\"]]],[[[1,\"    \"],[10,0],[14,0,\"cIC--cardBody\"],[14,\"data-test-id\",\"collapsable-info-card-content\"],[12],[1,\"\\n      \"],[10,0],[12],[1,\"\\n        \"],[18,6,null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@title\",\"@titleHelper\",\"@qaClass\",\"@showAsText\",\"&default\"],false,[\"did-insert\",\"if\",\"and\",\"on\",\"shared/ui/button\",\"t\",\"svg-jar\",\"unless\",\"yield\"]]",
    "moduleName": "shared/components/shared/collapsable-info-card.hbs",
    "isStrictMode": false
  });
  let CollapsableInfoCardComponent = _exports.default = (_class = (_handleToggleActions = /*#__PURE__*/new WeakSet(), class CollapsableInfoCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _handleToggleActions);
      _initializerDefineProperty(this, "isCollapsed", _descriptor, this);
    }
    toggleCollapsed() {
      this.isCollapsed = !this.isCollapsed;
      _classPrivateMethodGet(this, _handleToggleActions, _handleToggleActions2).call(this);
    }
    toggleMultiCalProfileKeyboard(event) {
      (0, _handleKeyUp.default)(event, _keys.default.SPACE, () => {
        this.isCollapsed = !this.isCollapsed;
        _classPrivateMethodGet(this, _handleToggleActions, _handleToggleActions2).call(this);
      });
    }
    hideOnInit() {
      if (this.args.hideOnInit) {
        this.toggleCollapsed();
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isCollapsed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleCollapsed", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCollapsed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMultiCalProfileKeyboard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMultiCalProfileKeyboard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideOnInit", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideOnInit"), _class.prototype)), _class);
  function _handleToggleActions2() {
    if (this.isCollapsed && (0, _utils.isPresent)(this.args.onCollapsedAction)) {
      this.args.onCollapsedAction();
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CollapsableInfoCardComponent);
});